import { useQuery } from "@tanstack/react-query";
import type { StoreMemberView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

export function useStoreMembersQuery(storeSlug: string) {
  const query = useQuery({
    queryKey: queryKeys.seller.members(storeSlug),
    queryFn: () => apiJsonClient<StoreMemberView[]>(endpoints.seller.members),
    enabled: storeSlug.length > 0,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
  };
}
